/* eslint-disable no-restricted-syntax */
const getErrorMessage = (resp) => {
    let msg = resp.message;
    if (resp.errors) {
        for (const err of Object.keys(resp.errors)) {
            msg = resp.errors[err].join(',\n');
        }
    }

    return msg;
};

export default { getErrorMessage };



// WEBPACK FOOTER //
// ./src/util/responseFormat.js